import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { CONFIG_ITEM_KEYS } from '../../../config-items/config-item-keys';
import { createEditorPluginAIConfigItemMarkdown } from '../../../config-items/config-items';
import { sliceOrNodeToMarkdown } from '../../../config-items/slice-or-node-to-markdown';
import { streamConvoAI } from '../../../provider/prompt-requests/convo-ai';
import { streamXPGenAI } from '../../../provider/prompt-requests/xp-gen-ai';
import { Icon } from '../../assets/icons/makeShorter';
import { createInsertBelow, createReplace } from '../../config-item-actions/markdown';
import { isMinLength } from '../../config-item-visible/visibility-utils';
import { getSlice } from '../utils';
import { messages } from './messages';
var SELECTION_TYPE = 'range';
export var shortenConfigItem = createEditorPluginAIConfigItemMarkdown({
  key: CONFIG_ITEM_KEYS.MAKE_SHORTER,
  title: messages.title,
  description: messages.description,
  selectionType: SELECTION_TYPE,
  getInitialContext: function getInitialContext(_ref) {
    var editorView = _ref.editorView,
      positions = _ref.positions,
      intl = _ref.intl,
      updateIdMap = _ref.updateIdMap,
      mentionMap = _ref.mentionMap;
    var selection = sliceOrNodeToMarkdown({
      slice: getSlice(editorView, positions),
      editorView: editorView,
      convertTo: 'markdown-plus',
      updateIdMap: updateIdMap,
      selectionType: SELECTION_TYPE,
      mentionMap: mentionMap
    });
    return {
      selection: selection.markdown,
      userLocale: intl.locale,
      intentSchemaId: 'shorten_intent_schema.json',
      contentStatistics: selection.contentStatistics
    };
  },
  triggerPromptRequest: function triggerPromptRequest(_ref2) {
    var initialContext = _ref2.initialContext,
      editorSchema = _ref2.editorSchema,
      analyticsContext = _ref2.analyticsContext;
    if (fg('platform_editor_ai_assistance_service')) {
      return streamConvoAI({
        aiSessionId: analyticsContext === null || analyticsContext === void 0 ? void 0 : analyticsContext.aiSessionId,
        userLocale: initialContext.userLocale,
        intentSchemaId: 'shorten_intent_schema.json',
        editorSchema: editorSchema,
        fullDocument: initialContext.document,
        currentSelection: initialContext.selection
      });
    }
    return streamXPGenAI({
      userLocale: initialContext.userLocale,
      intentSchemaId: 'shorten_intent_schema.json',
      editorSchema: editorSchema,
      contextList: [{
        type: 'ADF_MARKDOWN_V1',
        entity: initialContext.selection,
        relationship: 'SELECTION'
      }]
    });
  },
  isVisible: function isVisible(_ref3) {
    var editorView = _ref3.editorView,
      positions = _ref3.positions;
    return isMinLength({
      editorView: editorView,
      minLength: 1,
      positions: positions
    });
  },
  icon: function icon(_ref4) {
    var shownAt = _ref4.shownAt;
    return /*#__PURE__*/React.createElement(Icon, {
      shownAt: shownAt
    });
  },
  actions: [createInsertBelow({
    appearance: 'secondary'
  }), createReplace({
    appearance: 'primary'
  })],
  getBackendModel: function getBackendModel() {
    if (fg('platform_editor_ai_assistance_service')) {
      return 'assistance-service';
    }
    return 'xp-gen-ai';
  }
});